import { render, staticRenderFns } from "./CockpitNumberComponent.vue?vue&type=template&id=509213ba&scoped=true"
import script from "./CockpitNumberComponent.vue?vue&type=script&lang=js"
export * from "./CockpitNumberComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509213ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('509213ba')) {
      api.createRecord('509213ba', component.options)
    } else {
      api.reload('509213ba', component.options)
    }
    module.hot.accept("./CockpitNumberComponent.vue?vue&type=template&id=509213ba&scoped=true", function () {
      api.rerender('509213ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/cockpitFormCompontents/CockpitNumberComponent.vue"
export default component.exports